import { defineComponent as _defineComponent } from 'vue'
import { DateCellData } from "@/utils/CellsFactory";
import { computed } from "vue";
import { getFormatDate } from "@/utils/formatDates";

interface Props {
    data: DateCellData;
    value?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DateCell',
  props: {
    data: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
    data: DateCellData;
    value?: string | null;
}



const getDate = computed(() => {
    if (!props.value) return '';
    const format = props.data.format || 'dd.MM.yyyy';
    return getFormatDate(props.value, format);
});
const isShowTime = computed(() => props.value && !props.data.isHideTime);
const getTime = computed(() => {
    if (props.data.isHideTime) return '';
    const format = props.data.isSeconds ? 'HH:mm:ss' : 'HH:mm';
    return getFormatDate(props.value, format);
});

const getWeekDay = computed(() => getFormatDate(props.value, 'EEEEEE'));

return { __sfc: true,props, getDate, isShowTime, getTime, getWeekDay }
}

})